import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    br: "br",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: "제1조 (목적)"
    }), "\n", _jsx(_components.p, {
      children: "본 이용약관은 주식회사 셀러노트(이하 “회사”)가 제공하는 쉽다 서비스(이하 “서비스”)와 관련하여 회사와 이용고객 간의 서비스 내용, 이용조건, 절차, 권리 및 의무, 기타 필요한 사항을 규정함을 목적으로 합니다. 또한 본 이용약관은 서비스와 관련된 PC, 모바일웹 및 모바일앱을 이용하는 전자상거래에 대해서도 적용됩니다."
    }), "\n", _jsx(_components.h3, {
      children: "제2조 (용어의 정의 및 해석)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "'화주'는 국제물류주선을 의뢰하는 '서비스' 이용자로써 '홈페이지' 또는 '앱(APP)'을 통해 회원가입 이후 국제물류주선을 의뢰하거나 '홈페이지' 또는 고객용 '앱(APP)'을 통해서 회원가입 후 '서비스'를 이용할 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "'쉽다'는 ㈜셀러노트가 국제물류주선업 면허를 가지고 국제물류주선을 제공하는 서비스입니다."
      }), "\n", _jsx(_components.li, {
        children: "'이용고객'이란 쉽다 서비스를 이용하였거나 이용하고자 하는 '화주'를 의미합니다."
      }), "\n", _jsx(_components.li, {
        children: "'서비스'는 회사에서 쉽다를 통하여 '이용고객'에게 제공하는 모든 서비스를 의미합니다."
      }), "\n", _jsx(_components.li, {
        children: "'수출입 운송 견적 의뢰'는 화주가 물류 서비스가 필요한 지역 및 화물에 대한 정보를 등록하여 쉽다가 해당 건에 대하여 견적을 즉시 혹은 일정기간 내 제출하고 해당 정보를 확인한 화주가 수락 시, 수출입물류를 이행하는 서비스를 의미합니다."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제3조 (적용법규 등)"
    }), "\n", _jsx(_components.p, {
      children: "본 약관에 규정되지 않은 사항에 대하여는 정보통신망 이용촉진 및 정보보호 등에 관한 법률(정보통신망법), 전자상거래 등에서의 소비자보호에 관한 법률, 상법 등 관련법령과 상관례에 따릅니다."
    }), "\n", _jsx(_components.h3, {
      children: "제4조 (서비스의 제공 및 변경)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "서비스는 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간 제공을 원칙으로 합니다. 다만 정기 점검 등의 필요로 회사가 정한 날이나 시간은 제외됩니다. 정기점검시간은 서비스 제공화면을 통해 공지합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 회사의 지식재산권(저작권, 상표권, 로고, 그래픽, 사진, 애니메이션, 비디오 그리고 텍스트 또는 앱과 그 응용프로그램에 대한 권리를 포함하되 이에 한정하지는 아니함) 또는 회사의 소매 또는 광고 파트너의 지식재산에 대한 어떠한 권리도 이용고객에게 부여하지 아니합니다."
      }), "\n", _jsx(_components.li, {
        children: "이용고객들이 회사 서비스를 배제하고 별도로 거래하기를 요구할 경우 서비스 이용에 제한이 생길 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사가 제공하는 서비스와 앱의 사용은 무료입니다. 단, 회사가 제공한 서비스를 통해 이용고객은 제 5조에 따라 수수료를 지급할 의무를 가집니다."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제5조 (수수료 등)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "서비스 이용에 대한 '수수료'는 '회사에 의뢰한 수출입 물류 범위'에 적용되고, 해당 비용은 고객이 입력한 화물 정보가 아닌, 실제 도착지에 반입된 화물의 종류, 부피, 중량, 컨테이너 유형, 컨테이너 수 등을 고려한 기준에 따라 청구되며, 수출입 유형 및 인코텀즈에 따라 화주에게 해당 비용이 청구되는 시점은 아래와 같습니다."
        }), "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", _jsxs(_components.table, {
          children: [_jsx(_components.thead, {
            children: _jsxs(_components.tr, {
              children: [_jsx(_components.th, {
                style: {
                  textAlign: "left"
                },
                children: "구분"
              }), _jsx(_components.th, {
                style: {
                  textAlign: "left"
                },
                children: "수출"
              }), _jsx(_components.th, {
                style: {
                  textAlign: "left"
                },
                children: "수입"
              })]
            })
          }), _jsxs(_components.tbody, {
            children: [_jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "E조건(EXW)"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "해당사항 없음"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "도착지 항구/공항에 도착 시"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "F조건(FOB, FCA)"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "출발지 항구/공항에 선적 이후"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "도착지 항구/공항에 도착 시"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "C조건(CIF,CFR,CIP,CPT)"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "도착지 항구/공항에 도착 시"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "도착지 항구/공항에 도착 시"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "D조건(DAP, DDP)"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "최종 목적지에 도착 시"
              }), _jsx(_components.td, {
                style: {
                  textAlign: "left"
                },
                children: "해당사항 없음"
              })]
            })]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "화주의 요청에 따라 의뢰 이후 의뢰를 요청한 일정 업무(운송, 통관 등)를 수행하였는데, 사용자 요청에 따라 취소하는 경우에는 발생한 일체의 비용을 청구하며, 화주는 정당한 비용 청구에 대해 이의를 제기하지 않습니다."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "'수수료'는 회사가 인정하는 별도의 결제수단으로 결제될 수 있으며 상세한 '견적항목/비용/추가 가능한 실비내역'은 쉽다 서비스의 '견적서'를 통해 확인할 수 있습니다. 실제 모든 비용이 포함된 내역은 쉽다 서비스의 '거래명세서'를 통해 확인할 수 있습니다. 업무 특성상 견적서는 예상되는 비용이며, 거래명세서는 실제 운송을 진행하며 제반된 모든 비용의 합산입니다. 정산은 거래명세서 기준으로 진행됩니다."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "회사는 다음의 경우, 이용고객으로부터 추가수수료를 청구할 수 있습니다."
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "화주가 최초 요청한 범위 이외 화주의 필요에 따른 추가적인 업무처리 혹은 운송현황에 따라 추가적인 비용이 발생하게 될 경우. 회사는 화주에게 이 사실을 고지하고 예상 비용을 안내합니다."
          }), "\n", _jsx(_components.li, {
            children: "서면/유선으로 화주와 회사간 동의된 내용에 따라 이를 처리하고, 처리함에 따라 발생하는 '수수료'를 실비로 청구합니다."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "서비스와 관련하여 발생한 미납비용, 손해배상 등 이용고객의 회사에 대한 채무가 모두 정산될 때까지, 해당 이용고객의 서비스 사용이 중지되며, 그 채무가 일정기간 계속하여 변제되지 않을 경우에는 해당 이용고객의 회원자격이 박탈될 수 있습니다. 서비스 사용 중지 또는 회원자격 박탈에 대한 판단 기준은 회사의 약관 및 이용정책에 근거합니다."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "이용고객들이 본 약관 및 위 각 조항을 준수하지 않았을 경우, 회사는 본 약관 및 이용정책에 따라 손해배상 금액 등 각종 수수료를 부과하는 것 외에 계약을 해지할 수 있는 권리를 가집니다."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "회사는 본 서비스와 관련하여 발생한 미납경비, 손해배상 등 이용고객의 회사에 대한 채무가 정산되지 않을 경우 이용고객을 상대로 보전처분, 본안소송제기, 강제집행절차의 착수 등 채무 변제를 위한 법적 조치에 들어갈 수 있습니다."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제6조 (서비스 이용고객의 의무)"
    }), "\n", _jsx(_components.p, {
      children: "이용고객은 관계 법령과 약관의 규정, 이용 안내 등 회사가 고지하는 사항을 준수하여야 하며, 기타 회사 업무에 방해되는 행위를 하여서는 안됩니다.\n약관 등을 확인하지 않아 작업 중 발생한 문제의 책임은 전적으로 '이용고객' 본인에게 귀속되기에 약관 등을 신중히 검토한 후 서비스를 이용해야 합니다."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "'이용고객'은 시작 전에 반드시 상세 내용과 거래의 조건을 정확하게 확인해야 합니다. 거래 내용과 거래 조건을 확인하지 않고 거래를 진행하는데 발생한 모든 손실, 손해는 '이용고객'에게 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "'이용고객'은 직접 입력한 정보는 진실하여야 하며, 만일 이용자가 허위 기타 부정한 정보를 입력하여 회사 또는 다른 이용자에게 피해가 발생할 경우 그에 대한 민, 형사상의 책임을 포함한 일체의 책임은 이용고객 본인에게 귀속됩니다."
      }), "\n", _jsx(_components.li, {
        children: "'이용고객'은 '회사'가 정하고 인정하는 방식에 따라 서비스 등을 사용하여야 합니다."
      }), "\n", _jsxs(_components.li, {
        children: ["이용고객은 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "서비스 신청 또는 변경 시 허위 내용의 등록 행위"
          }), "\n", _jsx(_components.li, {
            children: "회사의 게시된 정보에 대해 회사로부터 허가를 받지 않은 변경 행위"
          }), "\n", _jsx(_components.li, {
            children: "회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등)를 송신 또는 게시하는 행위로서, 쉽다 서비스에 대한 인터넷 “링크”를 생성하거나 앱을 다른 서버 혹은 무선이나 인터넷 기반 디바이스에 “프레이밍” 또는 “미러링”하는 행위"
          }), "\n", _jsx(_components.li, {
            children: "타인의 개인정보 또는 ID와 비밀번호를 도용하는 행위"
          }), "\n", _jsx(_components.li, {
            children: "타인의 개인정보를 동의없이 수집, 저장, 공개 및 그 처리에 동의하는 행위"
          }), "\n", _jsx(_components.li, {
            children: "회사 기타 제3자의 저작권 등 지적 재산권에 대한 침해행위"
          }), "\n", _jsx(_components.li, {
            children: "회사 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위"
          }), "\n", _jsx(_components.li, {
            children: "외설 또는 폭력적인 메시지, 화상, 음성 기타 공공질서 미풍양속에 반하는 정보를 회사에 공개 또는 게시하는 행위"
          }), "\n", _jsx(_components.li, {
            children: "정당한 사유 없이 당사의 영업을 방해하는 내용을 기재하는 행위"
          }), "\n", _jsxs(_components.li, {
            children: ["일체의 가공행위를 통하여 서비스를 복제, 분해 또는 모방 기타 변형하는 행위로서 아래 열거된 목적으로 앱에 접속하는 행위\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: "리버스엔지니어링 또는 경쟁 제품이나 서비스를 디자인하거나 제작하기 위하여"
              }), "\n", _jsx(_components.li, {
                children: "서비스나 앱과 유사한 아이디어, 특징, 기능이나 그래픽이 사용되는 제품을 디자인하거나 제작하기 위하여"
              }), "\n", _jsx(_components.li, {
                children: "서비스나 앱의 아이디어, 특징, 기능이나 그래픽을 복제하기 위하여"
              }), "\n", _jsx(_components.li, {
                children: "자동 접속 프로그램 등을 사용하는 등 정상적인 용법과 다른 방법으로 서비스를 이용하여 회사의 서버에 부하를 일으켜 회사의 정상적인 서비스를 방해하는 행위로서 웹 스파이더, 웹 크롤러, 웹 로봇, 웹 개미, 웹 인덱서, 봇 바이러스나 웜 등의 자동 프로그램이나 스크립트의 실행에 착수하는 행위"
              }), "\n", _jsx(_components.li, {
                children: "기타 관계 법령이나 회사에서 정한 규정에 위배되는 행위"
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제7조 (운송의뢰 등록 상의 정보와 게시물)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "이용고객의 '운송의뢰 등록정보'와 '게시물'이 정보통신망법 및 저작권법 등 관련법에 위반되는 내용을 포함하는 경우, 회사는 관련법이 정한 절차에 따라 해당 '등록정보' 또는 '게시물'의 게시중단 및 삭제 등의 요청에 응하여야 하며 관련법에 따른 조치를 취하여야 합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 전항에 따른 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 '등록정보' 또는 '게시물'에 대해 임시조치 등을 취할 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "이용고객이 게시한 게시물의 저작권은 게시한 이용고객에게 귀속됩니다. 단, 회사는 서비스의 운영, 전시, 전송, 배포, 홍보의 목적으로 이용고객의 별도 허락 없이 무상으로 저작권법에 규정하는 공정한 관행에 합치되게 이용고객의 게시물을 사용할 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 전항 이외의 방법으로 이용고객의 게시물을 이용하고자 하는 경우, 전화, 전자우편 등의 방법을 통해 사전에 이용고객의 동의를 얻어야 합니다."
      }), "\n", _jsxs(_components.li, {
        children: ["이용고객이 작성한 '등록정보'나 '게시물'에 대한 모든 권리 및 책임은 이를 게시한 이용자에게 있으며, 회사는 이용자가 게시하거나 등록하는 서비스의 내용물이 다음 각 항에 해당한다고 판단되는 경우에 사전통지 없이 삭제할 수 있고, 이에 대하여 회사는 어떠한 책임도 지지 않습니다.\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "다른 이용자 또는 제3자를 비방하거나 명예를 손상시키는 내용인 경우"
          }), "\n", _jsx(_components.li, {
            children: "공공질서 및 미풍양속에 위반되는 내용일 경우"
          }), "\n", _jsx(_components.li, {
            children: "범죄적 행위에 결부된다고 인정되는 경우"
          }), "\n", _jsx(_components.li, {
            children: "회사의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우"
          }), "\n", _jsx(_components.li, {
            children: "음란물을 게재하거나 음란사이트를 링크하는 경우"
          }), "\n", _jsx(_components.li, {
            children: "회사로부터 사전 승인받지 아니한 상업광고, 판촉 내용을 게시하는 경우"
          }), "\n", _jsx(_components.li, {
            children: "해당 상품과 관련 없는 내용인 경우"
          }), "\n", _jsx(_components.li, {
            children: "정당한 사유 없이 당사의 영업을 방해하는 내용을 기재하는 경우"
          }), "\n", _jsx(_components.li, {
            children: "기타 관계법령에 위반된다고 판단되는 경우"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제8조 (서비스의 중단 및 이용 제한)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "회사는 이용 감소로 인한 원활한 서비스 제공의 곤란 및 수익성 악화, 기술 진보에 따른 차세대 서비스로의 전환 필요성, 서비스 제공과 관련한 회사 정책의 변경 등 기타 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경 또는 중단할 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 이용자에게 별도의 보상을 하지 않습니다."
      }), "\n", _jsx(_components.li, {
        children: "서비스의 내용, 이용방법, 이용시간에 대하여 변경 또는 서비스 중단이 있는 경우에는 변경 또는 중단될 서비스의 내용 및 사유와 일자 등은 그 변경 또는 중단 전에 회사 '웹사이트' 또는 서비스 내 '공지사항' 화면 등 이용자가 충분히 인지할 수 있는 방법으로 사전에 공지합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 이용고객이 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 전항에도 불구하고, '주민등록법'을 위반한 명의도용 및 결제도용, 전화번호 도용, '저작권법' 및 '컴퓨터프로그램보호법'을 위반한 불법프로그램의 제공 및 운영방해, '정보통신망법'을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 영구이용정지 시 서비스 이용을 통해 획득한 혜택 등도 모두 소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다."
      }), "\n", _jsx(_components.li, {
        children: "본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 회사의 이용제한정책에서 정하는 바에 의합니다."
      }), "\n", _jsx(_components.li, {
        children: "이용고객은 본 조에 따른 이용제한 등에 대해 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제9조 (해제 및 해지)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "이용고객은 본 약관에 의한 서비스 이용계약을 해지할 수 있습니다. 이용고객이 탈퇴를 신청한 경우 회사는 본인여부를 확인하여 신청에 따른 조치를 취합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 이용고객이 본 약관에서 정한 의무를 위반한 경우에는 사전 통보 후 이용계약을 해지할 수 있습니다. 다만, 이용고객이 현행법 위반 및 고의 또는 중대한 과실로 회사에 손해를 입힌 경우에는 사전통보 없이 이용계약을 해지할 수 있습니다."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제10조 (회사의 책임과 의무)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "화주가 쉽다 서비스를 통하여 운송 업무를 진행하게 되었을 때에는 '인코텀즈(Incoterms)' 및 운송에 따른 '추가 요청 사항'을 준수하여 업무상 책임 소재를 명확히 하여야 합니다. 단, 회사는 '운송 서비스'이지 '통관 서비스'가 아니기에 수출입 통관과 관련된 일체의 책임을 지지 않습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 관련법과 본 약관이 금하는 행위 및 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 이용고객이 안전하게 서비스를 이용할 수 있도록 개인정보보호를 위해 보안시스템을 갖추어야 하며 개인정보수집 및 처리방침을 공시하고 준수합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 관계 법령이 정한 의무사항을 준수합니다."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제11조 (회사의 면책)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 이용고객의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 이용자가 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 이용자 간 또는 이용자와 제 3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 4조 및 동법 제 44조의 7에 따라 이용 고객이 욕설, 비방 기타 모욕적인 게시글에 대하여 삭제할 재량을 갖습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 제3자가 서비스 내 화면 또는 링크된 웹사이트를 통하여 광고한 제품 또는 서비스의 내용과 품질에 대하여 감시할 의무 기타 어떠한 책임도 지지 아니합니다."
      }), "\n", _jsxs(_components.li, {
        children: ["회사 및 회사의 임직원 그리고 대리인은 다음과 같은 사항으로부터 발생하는 손해에 대해 책임을 지지 아니합니다.\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "이용고객의 허위정보 또는 부정확한 정보에 의해 발생하게 된 손해"
          }), "\n", _jsx(_components.li, {
            children: "그 성질과 경위를 불문하고 서비스에 대한 접속 및 서비스의 이용과정에서 발생하는 개인적인 손해"
          }), "\n", _jsx(_components.li, {
            children: "서버에 대한 제3자의 모든 불법적인 접속 또는 서버의 불법적인 이용으로부터 발생하는 손해"
          }), "\n", _jsx(_components.li, {
            children: "서버에 대한 전송 또는 서버로부터의 전송에 대한 제3자의 모든 불법적인 방해 또는 중단행위로부터 발생하는 손해"
          }), "\n", _jsx(_components.li, {
            children: "제3자가 서비스를 이용하여 불법적으로 전송, 유포하거나 또는 전송, 유포되도록 한 모든 바이러스, 스파이웨어 및 기타 악성 프로그램으로 인한 손해"
          }), "\n", _jsx(_components.li, {
            children: "전송된 데이터의 오류 및 생략, 누락, 파괴 등으로 발생되는 손해"
          }), "\n", _jsx(_components.li, {
            children: "이용자 간의 서비스 이용 과정에서 발생하는 명예훼손 기타 불법행위로 인한 각종 민형사상 책임"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제12조 (손해배상)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "본 약관을 숙지하고 동의한 후 쉽다 서비스를 이용하는 도중 이용고객이 행한 불법행위나 본 약관 내지 본 약관에서의 언급여부와 무관하게 관련 법령이나 규정을 위반한 경우 해당 이용고객은 자신의 책임과 비용(변호사 비용 포함)으로 회사를 면책시켜야 합니다."
      }), "\n", _jsx(_components.li, {
        children: "위 항과 관련하여 제3자가 회사 및 회사의 관련회사, 회사의 저작물, 그리고 회사의 각 임원, 사원, 다른 유저, 직원, 변호사, 대리인을 상대로 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 하는 경우에도 해당 이용고객은 자신의 책임과 비용(변호사 비용 포함)으로 이를 면책시켜야 합니다."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제13조 (이용약관의 변경)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "회사는 단독재량에 의하여 본 약관을 수시로 수정하거나 개정 또는 대체할 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 본 약관의 내용을 이용고객이 알 수 있도록 홈페이지에 게시하거나 앱 초기 화면에서 게시하는 방법으로 공지합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사는 「약관의 규제에 관한 법률」 「정보통신망이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령에 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다."
      }), "\n", _jsx(_components.li, {
        children: "회사가 약관을 개정할 경우에는 적용일자 및 개정내용, 개정사유 등을 명시하여 그 적용일자로부터 최소한 7일 이전(귀하를 포함한 고객에게 불리하거나 중대한 사항의 변경은 30일 이전)부터 그 적용일자 경과 후 상당한 기간이 경과할 때까지 위에서 정한 방법으로 공지합니다."
      }), "\n", _jsx(_components.li, {
        children: "회사가 개정약관 공지 시 동의 또는 거부의 의사표시를 하지 않으면 승낙한 것으로 간주하겠다는 내용도 함께 공지한 경우에는 개정약관 시행일 전까지 거부의사를 표시하지 않는다면 개정약관에 동의한 것으로 간주합니다."
      }), "\n", _jsx(_components.li, {
        children: "개정약관의 적용에 동의하지 않는 경우 회사 또는 해당 이용고객은 쉽다 서비스 이용 계약을 해지할 수 있습니다."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제14조 (개인정보보호)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "이용고객의 개인정보 수집, 사용, 저장, 양도는 일반적으로 회사의 개인정보수집 및 처리방침, 개인정보수집동의시 고지한 내용에 의하며, 그 최신버전은 회사의 홈페이지에 게시됩니다."
      }), "\n", _jsx(_components.li, {
        children: "회사의 재량에 의하여 개인정보취급방침은 때때로 수정되거나 업데이트 될 수 있으며, 본 약관에서 언급함으로써 본 약관에 포함됩니다."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "제15조 (준거법 및 관할법원)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "이 약관의 해석 및 회사와 이용고객 간의 분쟁에 대하여는 대한민국의 법을 적용합니다."
      }), "\n", _jsx(_components.li, {
        children: "서비스 이용 중 발생한 이용고객과 회사 간의 소송은 법령에 정한 절차에 따른 법원 또는 서울중앙지방법원을 관할 법원으로 합니다."
      }), "\n"]
    }), "\n", _jsx(_components.br, {}), "\n", _jsx(_components.p, {
      children: "본 약관은 2024 년 12 월 20 일부터 시행됩니다."
    }), "\n", _jsx(_components.h4, {
      children: "이용약관 변경에 관한 사항은 아래에서 확인하실 수 있습니다."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["2023.09.04 ~ 2024.12.19 적용 ", _jsx(_components.a, {
          href: "/policy/use/230904",
          children: "링크"
        })]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
